import React from "react";
import { useForm } from "react-hook-form";
import Grid from "@mui/material/Grid";
import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import { connect } from "react-redux";
import { useTheme, styled } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import logo from "../../_images/logos/LogoLimited.png";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import HelpIcon from "@mui/icons-material/Help";
import { LifeSafer } from "../../_helpers/BrandConstants";
import PropTypes from "prop-types";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import { brandColors } from "../../_components/brandedComponent/BrandedColors";
import ContinueButton from "./ContinueButton";
import { useParams } from "react-router-dom";

const LppInfo = ({ submitting, handleUpdate }) => {
  const cookies = new Cookies();
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isMobileSmall = useMediaQuery(theme.breakpoints.down("xs"));
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const enrolleeUser = JSON.parse(sessionStorage.getItem("enrolleeUser"));
  const { storyName } = useParams();
  const { handleSubmit, register, watch } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      protPlan: enrolleeUser?.protPlan ?? true,
    },
  });

  const isChecked = watch("protPlan");

  const toggleDrawer = (newOpen) => () => {
    setOpenDrawer(newOpen);
  };

  const CreditBox = styled(Grid)(() => ({
    minHeight: "100px",
    minWidth: "300px",
    maxWidth: isMobile ? "100%" : "50%",
  }));

  const onSubmit = (formData) => {
    let newData = {
      protPlan: formData.protPlan ? true : false,
    };

    let oldData = {
      EnrolleeId: enrolleeUser?.enrolleeId,
      ClientId: enrolleeUser?.clientId,
      UserId: enrolleeUser?.userId,
      firstName: enrolleeUser?.firstName,
      lastName: enrolleeUser?.lastName,
      dob: enrolleeUser?.dob,
      homeAddr1: enrolleeUser?.homeAddr1,
      homeAddr2: enrolleeUser?.homeAddr2,
      city: enrolleeUser?.city,
      zip: enrolleeUser?.zip,
      state: enrolleeUser?.state,
      county: enrolleeUser?.county,
      country: enrolleeUser?.country,
      dlState: enrolleeUser?.dlState || null,
      dlNum: enrolleeUser?.dlNum || "CE - NEED",
      dlExpirationDate: enrolleeUser?.dlExpirationDate,
      email: enrolleeUser?.email,
      homePhone: enrolleeUser?.homePhone,
      cellPhone: enrolleeUser?.cellPhone,
      workPhone: enrolleeUser?.workPhone,
      programType: enrolleeUser?.programType,
      contractEnd: enrolleeUser?.contractEnd,
      homeLat: enrolleeUser?.homeLat,
      homeLong: enrolleeUser?.homeLong,
      enrollmentCode:
        enrolleeUser?.enrollmentCode || enrolleeUser?.EnrollmentCode,
      enrollmentCodeId:
        enrolleeUser?.enrollmentCodeId ||
        enrolleeUser?.EnrollmentCodeId ||
        enrolleeUser?.EnrollmentCodeID,
      deviceType: enrolleeUser?.deviceType,
    };

    let updatedData = {
      ...oldData,
      ...newData,
    };

    handleUpdate("Lpp", updatedData);
  };

  return (
    <>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        sx={{ width: "100%" }}
        spacing={
          storyName?.toLowerCase() === "schedule" && !isMobile ? "25px" : "10px"
        }
      >
        {(!isMobile || storyName?.toLowerCase() === "schedule") && (
          <Grid
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <CreditBox
              style={{
                // padding: (storyName?.toLowerCase() === "schedule" && !isMobile) ? 10: 0,
                paddingLeft:
                  storyName?.toLowerCase() === "schedule" && !isMobile ? 10 : 8,
                paddingRight:
                  storyName?.toLowerCase() === "schedule" && !isMobile ? 10 : 8,
                paddingTop:
                  storyName?.toLowerCase() === "schedule" && !isMobile ? 10 : 0,
                paddingBottom:
                  storyName?.toLowerCase() === "schedule" && !isMobile ? 10 : 0,
                marginTop:
                  storyName?.toLowerCase() === "schedule" && !isMobile ? 15 : 0,
                border:
                  storyName?.toLowerCase() === "schedule" && !isMobile
                    ? `1px solid ${brandColors[brand].primary}`
                    : "none",
                borderRadius: 5,
              }}
            >
              <Grid
                container
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ textAlign: "center", fontWeight: "500" }}>
                  {t("steps.lppMessage")}
                </Typography>
              </Grid>
            </CreditBox>
          </Grid>
        )}
        <form
          style={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
          }}
          className="form"
          onSubmit={handleSubmit(onSubmit)}
        >
          <Grid style={{ maxWidth: "300px", width: "100%" }}>
            <Grid container alignItems="center" justifyContent="center">
              <Grid
                style={{
                  width: 196,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  border: `2px solid ${brandColors[brand].tertiary}`,
                  borderRadius: "5px",
                  position: "relative",
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      {...register("protPlan")}
                      size="large"
                      icon={<VerifiedUserOutlinedIcon />}
                      checkedIcon={<VerifiedUserIcon />}
                      checked={watch("protPlan")}
                      sx={{
                        "&.Mui-checked": {
                          color: brandColors[brand].secondary,
                        },
                      }}
                      disabled={submitting}
                    />
                  }
                  label={
                    isChecked
                      ? t("body.lossProtection")
                      : t("body.noProtection")
                  }
                  style={{
                    fontWeight: 600,
                    color: isChecked ? undefined : "#d1495b",
                  }}
                />
                {isMobile && storyName?.toLowerCase() !== "schedule" && (
                  <Grid
                    sx={{
                      display: "flex",
                      position: "absolute",
                      top: "-15px",
                      right: "-25px",
                    }}
                  >
                    <HelpIcon color="primary" onClick={toggleDrawer(true)} />
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>

          <Grid style={{ width: "100%" }}>
            <Grid
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                marginTop: "25px",
              }}
            >
              <ContinueButton submitting={submitting} />
            </Grid>
          </Grid>
        </form>

        <Drawer anchor="bottom" open={openDrawer} onClose={toggleDrawer(false)}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              borderTop: `2px solid ${brandColors[brand].primary}`,
            }}
          >
            <Box
              sx={{
                width: "100%",
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                py: 1,
              }}
            >
              <Grid sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <img
                  src={logo}
                  alt="logo"
                  style={{
                    height: isMobileSmall ? "26px" : "18px",
                    width: isMobileSmall ? "150px" : "100px",
                  }}
                />
                <Typography
                  sx={{
                    fontWeight: "bold",
                    color: brandColors[brand].primary,
                    mt: isMobileSmall ? "8px" : "2px",
                    fontStyle: "italic",
                    fontSize: isMobileSmall ? "24px" : "20px",
                  }}
                >
                  {t("steps.lossProtectionPlan")}
                </Typography>
              </Grid>
              <IconButton
                sx={{
                  position: "absolute",
                  right: isMobileSmall ? "20px" : "0px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "red",
                }}
              >
                <CloseIcon
                  sx={{ fontSize: "18px" }}
                  onClick={toggleDrawer(false)}
                />
              </IconButton>
            </Box>
          </Box>
          <Grid>
            <Box sx={{ display: "flex", width: "100%", pb: 2, px: 1 }}>
              <Typography sx={{ fontSize: "14px" }}>
                {t("steps.lppMessage")}
              </Typography>
            </Box>
          </Grid>
        </Drawer>
      </Grid>
    </>
  );
};

function mapStateToProps() {
  return {};
}

const mapDispatchToProps = {};

LppInfo.propTypes = {
  goToNextStep: PropTypes.func,
  handleUpdate: PropTypes.func,
  vehicleList: PropTypes.array,
  submitting: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(LppInfo);
